<template>
  <div data-cy="base-user-menu">
    <v-menu class="my-2" offset-y left nudge-right="2">
      <template v-slot:activator="{ on }">
        <v-btn
            v-on="on"
            class="mx-4"
            outlined
            data-cy="menu-account"
            height="38"
            style="min-width: 200px;"
        >
          <v-row justify="space-between" class="px-2">
            <v-icon size="24" left>mdi-account</v-icon>

            {{ username }}

            <v-icon size="24" right>mdi-chevron-down</v-icon>
          </v-row>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
            data-cy="personal-settings"
            @click="$emit('openPersonalSettings')"
        >
          <v-icon size="24" color="primary" left>mdi-account-cog</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_PersonalSettings")
            }}</span>
        </v-list-item>
        <!--v-list-item
          data-cy="personal-settings"
          @click="$emit('openzationSelect')"
        >
          <v-icon size="24" color="primary" left>mdi-office-building</v-icon>
          <span class="font-weight-bold primary--text">{{
            i18n.t("_SelectOrganization")
          }}</span>
        </v-list-item-->
        <v-divider class="my-1"></v-divider>
        <v-list-item data-cy="docs" @click="openDocumentation()">
          <v-icon size="24" color="primary" left>mdi-chevron-right</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_Documentation")
            }}</span>
        </v-list-item>
        <v-list-item data-cy="imprint" @click="openImprint()">
          <v-icon size="24" color="primary" left>mdi-chevron-right</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_Imprint")
            }}</span>
        </v-list-item>
        <v-list-item data-cy="data-privacy" @click="openDataPrivacy()">
          <v-icon size="24" color="primary" left>mdi-chevron-right</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_DataPrivacy")
            }}</span>
        </v-list-item>
        <v-list-item data-cy="send-email" @click="sendEmail()">
          <v-icon size="24" color="primary" left>mdi-chevron-right</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_Contact")
            }}</span>
        </v-list-item>
        <v-divider class="my-1"></v-divider>

        <v-list-item data-cy="logout" @click="logout()">
          <v-icon size="24" color="primary" left>mdi-logout</v-icon>
          <span class="font-weight-bold primary--text">{{
              i18n.t("_Logout")
            }}</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import i18n from "../helper/i18n"
export default {
  props: {
    username: {
      type: String,
      default: ""
    },
    /*    organization: {
      type: String,
      default: ""
    },*/
    docsUrl: {
      type: String,
      required: true,
      default: ""
    },
    imprintUrl: {
      type: String,
      default: "https://proficloud.io/site-notice/"
    },
    dataPrivacyUrl: {
      type: String,
      default:
          "https://www.phoenixcontact.com/en-pc/legal-information/data-privacy"
    },
    contactAdress: {
      type: String,
      default: "vmm-infrastructure-support@phoenixcontact.com"
    },
    subject: {
      type: String,
      default: "Grovez.io - Request"
    },
  },
  data() {
    return {
      i18n: i18n,
    };
  },
  methods: {
    openDocumentation() {
      window.open(this.docsUrl, "_blank").focus();
    },
    openDataPrivacy() {
      window.open(this.dataPrivacyUrl, "_blank").focus();
    },
    openImprint() {
      window.open(this.imprintUrl, "_blank").focus();
    },
    sendEmail() {
      window.open("mailto:" + this.contactAdress + "?subject=" + this.subject);
    },
    logout() {
      this.$router.push("/");
      this.keycloak.logout();
    }
  },
};
</script>

<style scoped>
* {
  text-transform: none !important;
}

.centered-input >>> input {
  text-align: center;
}
</style>
